import { Button, Row, styled, useTheme } from '@teko/ds-desktop';
import { useDistanceTerminalContext, useTenantConfig } from 'contexts';
import { TerminalPickerItem } from 'modules/terminal/desktop/TerminalPickerItem';
import React, { useEffect, useState } from 'react';
import { t } from 'i18n';
import { ISupermarketTerminal } from '@teko/order';
import { Spinner } from './ModeEnterAddress';
import { PenColored } from '@teko/ds-icon';
import { SwitchGetByGeoLocation } from './SwitchGetByGeoLocation';

export const ModeListTerminal = () => {
  const {
    currentTerminal,
    setNewTerminal,
    isLoadingGetDistanceTerminals,
    setIsModeEnterAddress,
    isModeEnterAddress,
    isGetCurrentLocation,
    temporaryDataDistanceTerminal,
    currentTerminals = [],
  } = useDistanceTerminalContext();
  const { colors } = useTheme();
  const [terminal, setTerminal] = useState<ISupermarketTerminal | undefined>(
    undefined,
  );
  const { epicOmni1589 } = useTenantConfig();
  const { location: locationGetDistanceTerminals } =
    temporaryDataDistanceTerminal;

  useEffect(() => {
    if (
      !!currentTerminals &&
      Array.isArray(currentTerminals) &&
      !!currentTerminals.length &&
      !isModeEnterAddress
    ) {
      setTerminal?.(
        !!currentTerminal
          ? currentTerminals.find(
              (t) => t.terminalId === currentTerminal.terminalId,
            ) || currentTerminals?.[0]
          : currentTerminals?.[0],
      );
    }
  }, [currentTerminal, currentTerminals, isModeEnterAddress]);

  if (isLoadingGetDistanceTerminals) {
    return (
      <Wrapper
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spinner />
      </Wrapper>
    );
  }

  const onUpdateAddress = () => {
    setIsModeEnterAddress?.(!isModeEnterAddress);
  };

  return (
    <>
      {isGetCurrentLocation && <SwitchGetByGeoLocation />}
      <Header justify="space-between">
        {isGetCurrentLocation ? (
          <Title style={{ marginLeft: 4, width: '75%' }}>
            {t('Đang sử dụng vị trí hiện tại của bạn')}
          </Title>
        ) : (
          <Title style={{ marginLeft: 4, width: '75%' }}>
            Địa chỉ: {locationGetDistanceTerminals?.address},{' '}
            {locationGetDistanceTerminals?.wardName},{' '}
            {!epicOmni1589
              ? `${locationGetDistanceTerminals?.districtName}, `
              : ''}
            {locationGetDistanceTerminals?.provinceName}
          </Title>
        )}

        <Row onClick={onUpdateAddress} style={{ cursor: 'pointer' }}>
          <PenColored size={20} />
          <Title
            style={{
              fontWeight: 'initial',
              color: colors.primary,
              marginLeft: 8,
            }}
          >
            {t('Thay đổi')}
          </Title>
        </Row>
      </Header>
      <Title>
        {temporaryDataDistanceTerminal?.terminals?.length}{' '}
        {t('siêu thị gần bạn')}:
      </Title>
      <Wrapper>
        {temporaryDataDistanceTerminal?.terminals?.map((item) => {
          return (
            <TerminalPickerItem
              key={item.terminalId}
              onClick={() => setTerminal(item)}
              isChoice={terminal?.terminalId === item.terminalId}
              terminalName={item.terminalName}
              distance={item.distance}
              terminalAddress={item.fullAddress}
            />
          );
        })}
      </Wrapper>
      <Button
        block
        onClick={() => {
          if (!!terminal) {
            setNewTerminal?.(terminal);
          }
        }}
        variant="primary"
        disabled={!terminal || isLoadingGetDistanceTerminals}
      >
        {t('Mua sắm ngay')}
      </Button>
    </>
  );
};

const Title = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const Wrapper = styled.div`
  height: 30vh;
  overflow: auto;
  margin-bottom: 16px;
`;

const Header = styled(Row)`
  width: 100%;
  padding-bottom: 16px;
  margin-bottom: 16px;
`;
